import { ISection } from '../../../interfaces/scheduler_interfaces';
import { ScheduledSectionStatus } from '../types/scheduled_section_status_enum';
import { Section } from '../../sections/builders/section_builder';
import * as _4 from 'lodash4';

export class SectionStatusServant {
  static sectionStatus(section: Section | ISection): string {
    return section.status;
  }

  static hasStatus(section: Section | ISection): any {
    return !_4.isUndefined(ScheduledSectionStatus[section.status]);
  }

  static isCompleted(section: Section | ISection) {
    return _4.isEqual(section.status, ScheduledSectionStatus.COMPLETED);
  }

  static isStatusCompleted(section: Section | ISection) {
    return _4.isEqual(section.status, ScheduledSectionStatus.COMPLETED);
  }

  static isStatusPending(section: Section | ISection) {
    return _4.isEqual(section.status, ScheduledSectionStatus.PENDING);
  }

  static isStatusFailed(section: Section | ISection) {
    return _4.isEqual(section.status, ScheduledSectionStatus.FAILED);
  }
  static isStatusFailedDrop(section: Section | ISection) {
    return _4.isEqual(section.status, ScheduledSectionStatus.DROPFAILED);
  }

  static isStatusRegistered(section: Section | ISection) {
    return _4.isEqual(section.status, ScheduledSectionStatus.REGISTERED);
  }

  static isStatusInProgress(section: Section | ISection) {
    return _4.isEqual(section.status, ScheduledSectionStatus.IN_PROGRESS);
  }

  static isRegisteredOrInprogress(section: Section | ISection) {
    return SectionStatusServant.isStatusInProgress(section) || SectionStatusServant.isStatusRegistered(section);
  }

  static isStatusWaitlisted(section: Section | ISection) {
    if (!section) {
      return false;
    }
    const waitlistedSectionStatuses = ScheduledSectionStatus.getWaitlistedSectionStatuses();
    return _4.includes(waitlistedSectionStatuses, section.status);
  }

  static isStatusWithdrawn(section: Section | ISection) {
    return _4.isEqual(section.status, ScheduledSectionStatus.WITHDRAWN);
  }

  static isStatusWaitlistFailed(section: Section | ISection) {
    return _4.isEqual(section.status, ScheduledSectionStatus.WAITLISTFAILED);
  }

  static isStatusWaitlistDropFailed(section: Section | ISection) {
    return _4.isEqual(section.status, ScheduledSectionStatus.WAITLISTDROPFAILED);
  }

  static isStatusUnscheduled(section: Section | ISection) {
    return _4.isEqual(section.status, ScheduledSectionStatus.UNSCHEDULED);
  }

  static isStatusRegisteredOrCompleteOrInProgress(section: Section | ISection) {
    return (
      SectionStatusServant.isStatusRegistered(section) ||
      SectionStatusServant.isStatusCompleted(section) ||
      SectionStatusServant.isStatusInProgress(section)
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/servants/section_status_servant.ts